export default __webpack_public_path__ + "static/media/order-summary-reject.61f2403f.svg";